// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import LinkPresentationPropsDefault from "@insite/mobius/Link/presentationProps";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { fontConfig } from "@vanmeter/XDL/constants";
import { xBaseTheme } from "@vanmeter/XDL/types";
import { color, getSystemColor } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...LinkPresentationPropsDefault,
        mergeCss: true,
        typographyProps: {
            ...fontConfig.regularSingleLine,
            weight: fontConfig.weight.bold,
            css: css`
                letter-spacing: 0;
            `,
        },
        css: css`
            & ${IconWrapper} {
                transition: all 0s;
            }
            &[disabled],
            &[aria-disabled="true"] {
                cursor: not-allowed;
                & ${TypographyStyle} {
                    color: ${color("text.link", 0.44)};
                }
                & ${IconWrapper} {
                    opacity: 0.44;
                    color: ${color("text.link")};
                }
                &:hover {
                    ${IconWrapper} {
                        opacity: 0.44;
                        color: ${color("text.link")};
                    }
                }
            }
        `,
        variant: {
            secondary: {
                color: "secondary.main",
                hoverStyle: {
                    color: getSystemColor("common.ui17"),
                },
            },
        },
    },
    primary: {
        color: "primary.main",
        hoverStyle: {
            color: getSystemColor("common.ui15"),
        },
    },
    secondary: {
        color: "secondary.main",
        hoverStyle: {
            color: getSystemColor("common.ui17"),
        },
    },
    tertiary: {
        color: "common.ui8",
        hoverStyle: {
            color: getSystemColor("common.ui19"),
        },
    },
    quarternary: {
        color: "common.ui7",
        hoverStyle: {
            color: getSystemColor("common.ui15"),
        },
    },
} as xBaseTheme["link"];
